module.exports = __webpack_public_path__ + "media/images/logo-b8c219ce558e8baddf0f51a70500af5b.png";